import React, {useEffect} from 'react';
import PropTypes from 'prop-types'
import {makeStyles} from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles(() => ({
    root: {
        paddingBottom: '50px'
    },
    imgContainer: {
        textAlign: 'center',
        marginTop: 20,
    },
    imgContainerSmall: {
        display: 'flex',
        marginBottom: 20,
    },
    img: {
        //width: 75,
    },
    imgSmall: {
        width: 40,
        marginRight: 22
    },
}));


function WhyComponent({imgSrc, title, desc}) {
    const classes = useStyles();

    useEffect(() => {
    }, []);

    return (
        <Grid container className={classes.root}>
            <Hidden only={['xs','sm']}>
                <Grid item sm={3} xl={1} className={classes.imgContainer}><img src={imgSrc} alt="Icon décoratif" className={classes.img}/></Grid>
                <Grid item sm={9} xl={11} style={{paddingLeft: 20}}>
                    {title}
                    <br/>
                    <br/>
                    {desc}
                </Grid>
            </Hidden>
            <Hidden only={['md','lg','xl']}>
                <Grid item xs={12} className={classes.imgContainerSmall}>
                    <div>
                    <img src={imgSrc} alt="Icon décoratif" className={classes.imgSmall}/>
                    </div>
                    {title}
                </Grid>
                <Grid item xs={12}>
                    {desc}
                </Grid>
            </Hidden>
        </Grid>
    )
}

WhyComponent.propTypes = {
    imgSrc: PropTypes.string.isRequired,
    title: PropTypes.object.isRequired,
    desc: PropTypes.object.isRequired
};

export default WhyComponent